module.exports = __webpack_public_path__ + "img/spinner-solid.8674e352.svg";